import {CornerDialog, Pane, toaster} from "evergreen-ui";
import type {HeaderTableType} from "./../../../types/header-table.type";
import {useEffect, useState} from "react";
import DatatableODTE from "./../../component/datatable";
import type {DatatableUtilisateurType} from "./../../../types/datatable-utilisateur.type";
import {UtilisateurService} from "./../../../services/utilisateur.service";
import Headerpanel from "../../component/headerpanel";
import type {UtilisateurType} from "../../../types/utilisateur.type";
import {useNavigate} from "react-router-dom";

export const Utilisateurs = () => {
   const HeaderLabel: HeaderTableType[] = [
      {key: "nom", label: "Nom", isFilter: true},
      {key: "prenom", label: "Prénom", isFilter: true},
      {key: "login", label: "Login", isFilter: false},
      {key: "email", label: "Email", isFilter: true},
      {key: "isActive", label: "statut", isFilter: false},
      {key: "action", label: "Action", isFilter: false},
   ];

   const title = "Liste des Utilisateurs";
   const [searchValue, setSearchValue] = useState("");

   const [dateValue, setDateValue] = useState("");

   const [listeUtilisateur, setListeUtilisateur] =
      useState<DatatableUtilisateurType>({
         utilisateurListe: [],
         totalRow: 0,
         currentPage: 0,
      });

   const [loading, setLoading] = useState<boolean>(true);
   // eslint-disable-next-line @typescript-eslint/no-unused-vars
   const [tempUtilisateur, setTemputilisateur] = useState<UtilisateurType>({
      id: undefined,
      nom: "",
      prenom: "",
      username: "",
      email: "",
      roles: ["ADMIN"],
      password: "",
      telephone: "",
      adresse: "",
   });
   const configAction: any = {
      edit: {
         state: true,
         url: `manage/`,
      },
      delete: {state: true, url: ""},
   };
   const [deleteModal, setDeleteModal] = useState<boolean>(false);
   const navigate = useNavigate();

   useEffect(() => {
      getListeUtilisateur();
   }, [listeUtilisateur.currentPage]);

   const getListeUtilisateur = () => {
      setLoading(true);
      UtilisateurService.getUtilisateurList({
         pageNo: listeUtilisateur.currentPage,
         pageSize: 10,
         sortBy: "",
         sortDir: searchValue,
      })
         .then(data => {
            setListeUtilisateur(prevState => ({
               ...prevState,
               utilisateurListe: data.utilisateurListe,
               currentPage: data.currentPage,
               totalRow: data.totalRow,
            }));
            setLoading(false);
         })
         .catch(() => {})
         .finally(() => {
            setLoading(false);
         });
   };

   function handleDeleteUtilisateur() {
      setDeleteModal(true);
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      const utilisateurId = tempUtilisateur.id.toString();
      if (utilisateurId !== "0") {
         void UtilisateurService.deleteUtilisateur(utilisateurId)
            .then(res => {
               if (res.success) {
                  toaster.success("OTDE NOTIFICATION", {
                     description: "Félicitation, le utilisateur a été supprimé",
                  });
                  // Rafraîchir la liste des utilisateurs après la suppression
                  getListeUtilisateur();
               }
            })
            .catch(() => {
               // Gérer les erreurs de suppression ici
               toaster.danger("OTDE NOTIFICATION", {
                  description:
                     "Une erreur s'est produite lors de la suppression du utilisateur.",
               });
            })
            .finally(() => {
               setDeleteModal(false);
            });
      }
   }

   const handleBtnSearch = () => {};

   const handleBtnExport = () => {};

   return (
      <div>
         <div className="px-4 sm:px-0"></div>
         <div className="mt-6 border-t border-gray-100">
            <dl className="divide-y divide-gray-100">
               <Headerpanel
                  title={title}
                  searchValue={searchValue}
                  dateValue={dateValue}
                  handleButtonExport={handleBtnExport}
                  handleButtonSearch={handleBtnSearch}
                  handleDateChanged={setDateValue}
                  showSeachValue={true}
                  showdatechoosed={true}
                  showexportPdf={true}
                  showSearchBtn={true}
                  showAddEntity={true}
                  handleAdd={() => {
                     navigate("manage");
                  }}
                  setSearchValue={setSearchValue}
               />
               <Pane
                  display="flex"
                  flexDirection={"row"}
                  padding={16}
                  borderRadius={3}>
                  <DatatableODTE
                     filterValue={searchValue}
                     tableHeaderlabel={HeaderLabel}
                     tableData={listeUtilisateur.utilisateurListe}
                     totalRow={listeUtilisateur.totalRow}
                     loading={loading}
                     handleCurrenyPage={currentP => {
                        setListeUtilisateur(prevState => ({
                           ...prevState,
                           currentPage: currentP,
                        }));
                     }}
                     configAction={configAction}
                     handleDelete={utilisateur => {
                        setTemputilisateur(utilisateur);
                        setDeleteModal(true);
                     }}
                  />
                  <CornerDialog
                     title="Gestion de l'application"
                     isShown={deleteModal}
                     confirmLabel={"Supprimer"}
                     cancelLabel={"Annuler "}
                     onConfirm={handleDeleteUtilisateur}
                     onCloseComplete={() => {
                        setDeleteModal(false);
                     }}>
                     Voulez-vous supprimer cette ligne ?
                  </CornerDialog>
               </Pane>
            </dl>
         </div>
      </div>
   );
};
